import React from "react"

import GrantHeaderComponent from './grant-header-component'

class GrantHeaderContainer extends React.Component {

	render() {
		return (
			<GrantHeaderComponent 
				row={this.props.row}
				onToggleGrants={this._handleToggleGrants.bind(this)}
			/>
		)
	}

	_handleToggleGrants() {
		this.props.onToggleGrants(this.props.row.type)
	}

}

export default GrantHeaderContainer



// WEBPACK FOOTER //
// ./src/component/ppi/ppi-detail/investments/grant-header-container.js